import { WebshopComponent } from '@app/webshop/shop/webshop.component';
import { OrderDetailsComponent } from '@app/webshop/order-details/order-details.component';
import { BasketOverviewComponent } from '@app/webshop/basket/basket-overview.component';
import { OrderOverviewComponent } from './order-overview/order-overview.component';
import { IhscDashboardComponent } from './dashboard/dashboard.component';

import { ConfirmOrderComponent } from './order/confirm-order/confirm-order.component';
import { Routes } from '@angular/router';
import { FavoritesComponent } from './favorites/favorites.component';
import { WebshopConfigurationComponent } from './configuration/configuration.component';
import {BasePermissionDefinition} from '@shared/permission/base-permission-definition';

export const WebshopMappingRoutes: Routes = [
    {
        path: 'articles/:id',
        component: WebshopComponent
    },
    {
        path: 'order-details/:id',
        component: OrderDetailsComponent
    },
    {
        path: 'categories/:id',
        component: WebshopComponent
    },
    {
        path: 'order-overview',
        component: OrderOverviewComponent
    },
    {
        path: 'favorites',
        component: FavoritesComponent
    },
    {
        path: 'basket-overview',
        component: BasketOverviewComponent
    },
    {
        path: 'confirm-order',
        component: ConfirmOrderComponent
    },
    {
        path: 'dashboard',
        component: IhscDashboardComponent
    },
    {
        path: 'configuration',
        component: WebshopConfigurationComponent
    },
    {
        path: 'field-agent',
        loadChildren: () => import('./field-agent/field-agent.module').then(m => m.FieldAgentModule), //Lazy load account module
        data: { preload: true }
    }
];
